export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    type: 'seq'
  },
  {
    field: 'checkbox',
    width: 40,
    align: 'center',
    type: 'checkbox'
  },
  {
    title: that.$l('INDEX.table_label_operation') || '操作',
    field: 'col-opt',
    width: 140,
    headerAlign: 'center',
    align: 'center',
    slots: {
      default: 'opt'
    }
  },
  {
    title: that.$l('INDEX.fabric_label_groupSpecName') || '规格名称',
    field: 'groupSpecName',
    headerAlign: 'center',
    align: 'center',
    width: 100,
    showHeaderOverflow: true,
    showOverflow: true,
    sortable: true,
    sortType: 'string',
  },
  {
    title: that.$l('INDEX.table_label_accessories_no') || '辅料编号',
    field: 'materialNo',
    width: 150,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    sortable: true,
    sortType: 'string',
  },
  {
    title: that.$l('INDEX.table_label_accessories_name') || '辅料名称',
    field: 'materialName',
    width: 150,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    sortable: true,
    sortType: 'string',
  },
  {
    title: that.$l('INDEX.table_label_accessories_specifications') || '辅料规格',
    field: 'materialSpec',
    width: 130,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    sortable: true,
    sortType: 'string',
  },
  {
    title: that.$l('INDEX.table_label_accessories_qty') || '辅料用量',
    field: 'qty',
    width: 80,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('INDEX.table_label_accessories_unit') || '辅料单位',
    field: 'materialUnit',
    width: 80,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('INDEX.form_label_isCommon') || '是否通用',
    field: 'isCommon',
    align: 'center',
    width: 100,
    showHeaderOverflow: true,
    showOverflow: true,
    slots: {
      default: 'isCommon'
    }
  },
  {
    title: that.$l('INDEX.batch_label_outBillType') || '出单类型',
    field: 'v_outBillType',
    headerAlign: 'center',
    align: 'center',
    width: 100,
    showHeaderOverflow: true,
    showOverflow: true,
    sortable: true,
    sortType: 'string',
  },
  {
    title: that.$l('INDEX.order_form_batch_label_dispatchPort') || '发运港口',
    field: 'v_dispatchPort',
    headerAlign: 'center',
    align: 'center',
    width: 130,
    showHeaderOverflow: true,
    showOverflow: true,
    sortable: true,
    sortType: 'string',
  },
  {
    title: that.$l('INDEX.order_form_batch_label_destinationPort') || '目的港口',
    field: 'v_destinationPort',
    headerAlign: 'center',
    align: 'center',
    width: 130,
    showHeaderOverflow: true,
    showOverflow: true,
    sortable: true,
    sortType: 'string',
  },
  {
    title: that.$l('INDEX.order_form_label_isCustomerProvide') || '是否客供',
    field: 'isCustomerProvide',
    align: 'center',
    width: 120,
    showHeaderOverflow: true,
    showOverflow: true,
    slots: {
      default: 'isCustomerProvide'
    }
  },
  {
    title: that.$l('INDEX.form_label_isSpecify') || '客户指定供应商',
    field: 'isSpecify',
    align: 'center',
    width: 120,
    showHeaderOverflow: true,
    showOverflow: true,
    slots: {
      default: 'isSpecify'
    }
  },
  {
    title: that.$l('INDEX.purchase_form_label_scmCode') || '供应商',
    field: 'scmName',
    minWidth: 150,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('INDEX.form_label_isFactoryConfirm') || '是否工厂确认',
    field: 'isFactoryConfirm',
    align: 'center',
    width: 120,
    showHeaderOverflow: true,
    showOverflow: true,
    slots: {
      default: 'isFactoryConfirm'
    }
  },
  {
    title: that.$l('INDEX.table_label_modified_by') || '修改人姓名',
    field: 'modifyByName',
    align: 'center',
    width: 120,
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('INDEX.table_label_modification_date') || '修改时间',
    field: 'modifyTime',
    align: 'center',
    width: 170,
    showHeaderOverflow: true,
    showOverflow: true
  }
]
